import React from 'react';

import fullViewDrone from '../../../main/assets/images/mrm2-10/full-view-propeller.webp';

export const SystemParameters = () => {
  return (
    <section className="mrm2-system-section">
      <div className="mrm2-system-product-container">
        <h2 className="mrm2-system-title">SYSTEM PARAMETERS</h2>
        <img
          src={fullViewDrone}
          alt="Close-up of a Drone Propeller"
          className="mrm2-system-product"
        />
      </div>
      <div className="mrm2-system-specs-column">
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">Motors and Propellers</h3>
          <p className="mrm2-system-specs-description">ORQA 2814 / 880 kV</p>
          <p className="mrm2-system-specs-description">
            10-inch dual-blade propellers
          </p>
        </div>
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">CAMERA</h3>
          <p className="mrm2-system-specs-description">ORQA Justice Analog</p>
          <p className="mrm2-system-specs-description">
            4:3 / 16:9 switchable aspect ratio
          </p>
          <p className="mrm2-system-specs-description">
            1200 TVL (suitable for low light)
          </p>
        </div>
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">RC Link</h3>
          <p className="mrm2-system-specs-description">
            EW-resilient Dual Sub-GHz
          </p>
          <p className="mrm2-system-specs-description">
            IRONghost 4xx/9xx MHz switchable bands C2 link power output
          </p>
        </div>
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">ESc</h3>
          <p className="mrm2-system-specs-description">ORQA 4IN1 70A</p>
          <p className="mrm2-system-specs-description">
            70A continuous 4-in-1 ESC
          </p>
          <p className="mrm2-system-specs-description">
            Pre-flashed with AM32 firmware
          </p>
        </div>
      </div>
      <div className="mrm2-system-specs-column">
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">Flight Controller</h3>
          <p className="mrm2-system-specs-description">ORQA H7 QuadCore</p>
          <p className="mrm2-system-specs-description">STM32H743 processor</p>
          <p className="mrm2-system-specs-description">ICM-42688 IMU</p>
          <p className="mrm2-system-specs-description">
            Orqa’s custom NDAA-Compliant OSD
          </p>
          <p className="mrm2-system-specs-description">
            Ardupilot, iNav, Betaflight & PX4 support
          </p>
          <p className="mrm2-system-specs-description">
            MAVLINK support & ATAK integration
          </p>
        </div>
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">Video Transmission</h3>
          <p className="mrm2-system-specs-description">
            5.8 GHz Analog Video Transmitter
          </p>
          <p className="mrm2-system-specs-description">
            Up to 5W VTx Power Output
          </p>
          <p className="mrm2-system-specs-description">
            Compatible with all current HD systems on the market
          </p>
        </div>
      </div>
    </section>
  );
};
